import angular from 'angular';

/**
 * Created by Maxim Seredkin.
 * @param project
 * @return {*}
 */
function formatDateToString(date) {
  if (!date) return null;
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}.${month}.${year}`;
}

function formatDateToYearNumber(date) {
  if (!date) return null;
  return new Date(date).getFullYear();
}

function formatDateToDayMonth(date) {
  if (!date) return null;
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  return `${day}.${month}`;
}

export function toForm(project) {
  let savingProject = angular.copy(project);

  if (!!savingProject.projectTaxes) {
    savingProject.projectTaxes = savingProject.projectTaxes.map((tax) => {
      return {
        id: tax.id,
        taxId: tax.tax.id,
        quarterId: tax.quarter.id,
        federalBudjet: tax.federalBudjet,
        regionalBudjet: tax.regionalBudjet,
      };
    });
  }

  if (!!savingProject.projectWorkPlaces) {
    savingProject.projectWorkPlaces = savingProject.projectWorkPlaces.map(
      (workPlace) => {
        return {
          id: workPlace.id,
          quarterId: workPlace.quarter.id,
          amount: workPlace.amount,
        };
      }
    );
  }

  if (!!savingProject.projectChronologies) {
    savingProject.projectChronologies = savingProject.projectChronologies.map(
      (chronology) => {
        return {
          id: chronology.id,
          eventDate: chronology.eventDate,
          content: chronology.content,
          note: chronology.note,
          attachmentIds: !!chronology.attachments
            ? chronology.attachments.map((attachment) => attachment.id)
            : [],
        };
      }
    );
  }

  if (!!savingProject.municipalityOrg) {
    savingProject.municipalityOrgId = savingProject.municipalityOrg.id;
  } else {
    savingProject.municipalityOrgId = null;
  }
  delete savingProject.municipalityOrg;

  if (!!savingProject.municipalityStaff) {
    savingProject.municipalityStaffId = savingProject.municipalityStaff.id;
  } else {
    savingProject.municipalityStaffId = null;
  }
  delete savingProject.municipalityStaff;

  savingProject.projectSubProgresses = savingProject.projectSubProgresses.map(
    (subProgress) => ({
      id: subProgress.id,
      name: subProgress.name,
      phaseId: subProgress.phase ? subProgress.phase.id : subProgress.phaseId,
      startDate: subProgress.startDate,
      endDate: subProgress.endDate,
      comment: subProgress.comment,
      planStartDate: formatDateToDayMonth(subProgress.planStartDate),
      planEndDate: formatDateToDayMonth(subProgress.planEndDate),
    })
  );

  // Форматируем даты в нужный формат
  if (savingProject.planStartYear) {
    const startDate = new Date(savingProject.planStartYear);
    savingProject.planStartYear = formatDateToYearNumber(startDate);
    savingProject.planStartDate = formatDateToDayMonth(startDate);
  }
  if (savingProject.planEndYear) {
    const endDate = new Date(savingProject.planEndYear);
    savingProject.planEndYear = formatDateToYearNumber(endDate);
    savingProject.planEndDate = formatDateToDayMonth(endDate);

  }

  return savingProject;
}
